import {ViewProps} from './model';
import {View} from 'react-native';
import * as React from 'react';
import {PollFormScreenWrapper} from '../components/pollForm';
import {Routes, Screens} from '../../../shared/routing';
import {GetPollResponsePayload} from '../../../shared/models/api';
import {useStyles} from '../../../shared/hooks/styles';
import {DeviceSize} from '../../../shared/theme/helpers';
import {Button} from '../../../shared/components/button';
import {PollQuestion} from '../components/pollQuestion';
import {PollsTypeVoteResultScreen} from '../voteResult';
import {useTheme} from '../../../shared/theme';
import {PollStatus} from '../../../shared/models/poll';
import {LoadableContent} from '../../../shared/components/loadableContent';
import Screen from '../../../shared/components/screen';

const getRoutes = (poll: GetPollResponsePayload) => [
  {
    title: 'Опросы и голосования',
    routeName: Screens.Polls,
    webRoute: Routes.polls,
  },
  {
    title: 'Голосования',
    routeName: Screens.PollsTypeVote,
    webRoute: Routes.pollsTypeVote,
  },
  {
    title: poll.name || '',
    routeName: Screens.PollsTypeVoteForm,
    webRoute: Routes.pollsTypeVoteForm,
  },
];

export default ({poll, isDesktop, onSubmit, isVoteCompleteNow, routeParams}: ViewProps) => {
  const theme = useTheme();
  const styles = useStyles(({mediaOnly}) => ({
    sectionContainer: {
      ...mediaOnly(DeviceSize.desktop, {width: 874}),
      marginHorizontal: 'auto',
    },
    title: {
      ...theme.fonts.h3,
      marginBottom: 20,
    },
    description: mediaOnly(DeviceSize.desktop, {marginBottom: 40}, {marginBottom: 20}),
    questionTitle: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.h4,
          marginBottom: 30,
        },
        {
          ...theme.fonts.action,
          marginBottom: 18,
        },
      ),
    },
    question: {
      marginTop: 30,
    },
    questionNotFirst: {
      marginTop: 0,
    },
    button: {
      ...mediaOnly(DeviceSize.mobile, {width: '100%'}, {width: 328}),
    },
  }));
  const pollId = +(routeParams.pollId ?? '0');

  if (!isDesktop && (poll?.statusId === PollStatus.Completed || poll?.isPassed)) {
    return <PollsTypeVoteResultScreen isVoteCompleteNow={isVoteCompleteNow} poll={poll} />;
  }

  return (
    <Screen>
      <LoadableContent loading={!poll || poll.id !== pollId}>
        {poll ? (
          <PollFormScreenWrapper
            titleStyle={styles.title}
            descriptionStyle={styles.description}
            submitButton={(onPress) => (
              <Button
                id='vote-finish'
                style={styles.button}
                type='secondary'
                onPress={onPress}
                text='Завершить голосование'
              />
            )}
            onSubmit={onSubmit}
            breadcrumbs={getRoutes(poll)}
            containerStyle={styles.sectionContainer}
            poll={poll}>
            <View>
              {poll.questions?.map((question, index) => (
                <PollQuestion
                  titleStyle={theme.fonts.h3}
                  key={question.id}
                  question={{...question, text: 'Варианты ответов'}}
                  index={index}
                  style={[styles.question, index === 0 ? styles.questionNotFirst : {}]}
                />
              ))}
            </View>
          </PollFormScreenWrapper>
        ) : null}
      </LoadableContent>
    </Screen>
  );
};
